const footerTemplate = {
  aboutTitle: 'TalkAbout.Finance',
  aboutText: 'Practical tools and plain-English guides to help you think more clearly about money decisions.',
  contactTitle: 'Social & contact',
  disclaimerTitle: 'Important note',
  disclaimerText: 'The information on this website is provided for general educational purposes only and does not constitute financial, legal, investment, or tax advice.',
  email: 'lets@talkabout.finance',
  instagram: {
    label: '@talkabout.finance.official',
    url: 'https://www.instagram.com/talkabout.finance.official',
  },
};

module.exports = footerTemplate;
